import React, { useEffect, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { usePayments } from '../hooks/usePayments';
import { ProfileContentContainerStyled, ProfileHeaderContainerStyled, ProfileTextStyled } from '../styles/Profile';
import { ContainerStyled, ModalBackgroundStyled, PageHeaderStyled } from '../styles/Main';
import Loading from './Loading';
import Products from './Products';
import { PlanViewContainerStyled, PlansButton } from '../styles/Form';
import { PrimaryButtonStyled, SecondaryButtonStyled } from '../styles/Button';
import { IconContext } from "react-icons";
import iconMap from '../data/iconMap';


const Profile = ({plans, selectedPlan, setSelectedPlan}) => { 
    const { user, logOut } = useAuth();
    const { getCurrentPlan, getCustomer, findPlan, manageSubscription, checkout } = usePayments();
    const [subscription, setSubscription] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [showPlans, setShowPlans] = useState(0);
    const [loading, setLoading] = useState(0);
    const [error, setError] = useState('');

    useEffect(() => {
        const getDetails = async () => {
            let sub = await getCurrentPlan(user.uid);
            let cust = await getCustomer(user.uid);
            setSubscription(sub)
            setCustomer(cust)
        }
        getDetails()
    }, [user.uid, getCurrentPlan, user.email, getCustomer])
    

    const loadCheckout = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(1);
        try {
            let p = findPlan(plans, selectedPlan)
            await checkout(p, user.uid, '/profile', '/profile' )
        } catch (error) {
            setLoading(0)
            const errorCode = error.code;
            const errorMessage = error.message;
            setError(errorMessage)
            console.log(errorCode, errorMessage);
        }
    }

    const loadBillingPortal = async () => {
        setError('');
        setLoading(1);
        try {
            await manageSubscription(customer.stripeId)
            setLoading(0)
        } catch (error) {
            setLoading(0)
            const errorCode = error.code;
            const errorMessage = error.message;
            setError(errorMessage)
            console.log(errorCode, errorMessage);
        }
    }

    return (
        <ContainerStyled>
            {
                loading?
                <Loading message={"Loading..."}/>
                :null
            }
            
            {
                showPlans===1?
                <ModalBackgroundStyled>
                    <Products
                    plans={plans} 
                    setShowPlans={setShowPlans} 
                    selectedPlan={selectedPlan} 
                    setSelectedPlan={setSelectedPlan}
                    onContinue={loadCheckout}
                    continueText={'Continue to Pay'}
                    loading={plans.length>0}
                    />
                </ModalBackgroundStyled>
                :
                null
            } 
            <ProfileContentContainerStyled>
                <ProfileHeaderContainerStyled>
                    <PageHeaderStyled>Profile</PageHeaderStyled>
                    <h4>Email: {user.email.length>35?`${user.email.slice(0,35)}..`:user.email}</h4>
                </ProfileHeaderContainerStyled>
                
                {   customer && subscription?.status?
                    <>
                        <ProfileTextStyled>
                            Status: <IconContext.Provider value={{ style: { fontSize: '10px', marginRight: '2px', color: subscription?.status==='active'?'green':'red' } }}>{iconMap['Circle']}</IconContext.Provider><span style={{color: subscription?.status==='active'?'green':'red'}}>{subscription?.status.charAt(0).toUpperCase() + subscription?.status.slice(1)}</span> </ProfileTextStyled>
                        <ProfileTextStyled>Queries Remaining: {customer.queries}</ProfileTextStyled>
                        <ProfileTextStyled>Plan: ${subscription?.plan.price.unit_amount/100} / {subscription?.plan.plan.interval}</ProfileTextStyled>
                        <ProfileTextStyled>Member since: {subscription?.current_period_start_date}</ProfileTextStyled>
                        <ProfileTextStyled>Renewal date: {subscription?.current_period_end_date}</ProfileTextStyled>
                        {
                            subscription?.status!=='active'?
                                plans.length>0?
                                <PlanViewContainerStyled>
                                    Selected Plan: {plans.filter(p => p.prices.priceId === selectedPlan)[0].name}
                                    {'  '}${plans.filter(p => p.prices.priceId === selectedPlan)[0].prices.priceData.unit_amount/100}
                                    <PlansButton onClick={() => setShowPlans(1)}>Show plans</PlansButton>
                                </PlanViewContainerStyled>
                                :<div>Loading plans...</div>
                            :null
                        }
                        <PrimaryButtonStyled onClick={loadBillingPortal}>Manage Account</PrimaryButtonStyled>
                    </>:
                    subscription===null && customer===null?
                    <div>Loading...</div>:
                    <div>
                        <p>Please pay for an account before talking to the assistant</p>
                        {error!==''?<p>{error}</p>:null}
                        {
                            plans.length>0?
                            <PlanViewContainerStyled>
                                Selected Plan: {plans.filter(p => p.prices.priceId === selectedPlan)[0].name}
                                {'  '}${plans.filter(p => p.prices.priceId === selectedPlan)[0].prices.priceData.unit_amount/100}
                                <PlansButton onClick={() => setShowPlans(1)}>Show plans</PlansButton>
                            </PlanViewContainerStyled>
                            :<div>Loading plans...</div>
                        }
                    </div>
                    
                }
            </ProfileContentContainerStyled>
            <SecondaryButtonStyled onClick={() => logOut()}>Signout</SecondaryButtonStyled>
        </ContainerStyled>
    )
}
 
export default Profile;